import React from 'react';
import { Container } from './ui/Container';
import { Facebook, Youtube, MapPin, Phone, Clock, Mail } from 'lucide-react';
export function Footer() {
  return <footer className="bg-nav text-gray-300 pt-16 pb-8 border-t-4 border-accent" data-id="element-74">
      <Container data-id="element-75">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12" data-id="element-76">
          {/* Brand / Logo */}
          <div className="flex flex-col items-start" data-id="element-77">
            <img src="https://cdn.magicpatterns.com/uploads/eVMZQm7Ubb8XC5WRaeeaDm/DragonMartialArts-Logo.png" alt="Dragon Martial Arts of Round Lake logo" className="w-24 h-24 mb-6 bg-white rounded-full p-2" data-id="element-78" />
            <h3 className="text-white font-heading font-bold text-lg mb-2" data-id="element-79">
              Dragon Martial Arts of Round Lake
            </h3>
            <p className="text-sm text-accent font-bold uppercase tracking-wide mb-6" data-id="element-80">
              Taekwondo for All Ages
            </p>
            <div className="flex space-x-4" data-id="element-81">
              <a href="https://www.facebook.com/DragonMartialArtsofRoundLake" target="_blank" rel="noopener noreferrer" className="bg-gray-800 p-2 rounded-full hover:bg-accent hover:text-white transition-colors" data-id="element-82">
                <Facebook size={20} data-id="element-83" />
              </a>
              <a href="https://www.youtube.com/channel/UCuJLpS3IFW06RbZAo-l7mtA?view_as=subscriber" target="_blank" rel="noopener noreferrer" className="bg-gray-800 p-2 rounded-full hover:bg-accent hover:text-white transition-colors" data-id="element-84">
                <Youtube size={20} data-id="element-85" />
              </a>
            </div>
            <div className="mt-6 text-xs text-gray-500 font-medium" data-id="element-86">
              Kukkiwon | WTF | USNTF | ITSO
            </div>
          </div>

          {/* Quick Links */}
          <div data-id="element-87">
            <h4 className="text-white font-heading font-bold text-lg mb-6 uppercase tracking-wide" data-id="element-88">
              Quick Links
            </h4>
            <ul className="space-y-3" data-id="element-89">
              <li data-id="element-90">
                <a href="https://dragonmartialarts-rl.com/" className="hover:text-accent transition-colors" data-id="element-91">
                  Home
                </a>
              </li>
              <li data-id="element-92">
                <a href="https://dragonmartialarts-rl.com/about-us/" className="hover:text-accent transition-colors" data-id="element-93">
                  About Us
                </a>
              </li>
              <li data-id="element-94">
                <a href="#classes" className="hover:text-accent transition-colors" data-id="element-95">
                  Classes
                </a>
              </li>
              <li data-id="element-96">
                <a href="https://dragonmartialarts-rl.com/blog/" className="hover:text-accent transition-colors" data-id="element-97">
                  Blog
                </a>
              </li>
              <li data-id="element-98">
                <a href="https://dragonmartialarts-rl.com/contact-us/" className="hover:text-accent transition-colors" data-id="element-99">
                  Contact Us
                </a>
              </li>
            </ul>
          </div>

          {/* Hours & Address */}
          <div data-id="element-100">
            <h4 className="text-white font-heading font-bold text-lg mb-6 uppercase tracking-wide" data-id="element-101">
              Visit Us
            </h4>
            <ul className="space-y-4" data-id="element-102">
              <li className="flex items-start" data-id="element-103">
                <MapPin className="w-5 h-5 mr-3 text-accent flex-shrink-0 mt-0.5" data-id="element-104" />
                <span data-id="element-105">
                  655 Railroad Ave.
                  <br data-id="element-106" />
                  Round Lake, IL 60073
                </span>
              </li>
              <li className="flex items-center" data-id="element-107">
                <Phone className="w-5 h-5 mr-3 text-accent flex-shrink-0" data-id="element-108" />
                <a href="tel:8472128045" className="hover:text-white transition-colors" data-id="element-109">
                  (847) 212-8045
                </a>
              </li>
              <li className="pt-2 border-t border-gray-800 mt-2" data-id="element-110">
                <div className="flex justify-between text-sm mb-1" data-id="element-111">
                  <span data-id="element-112">Mon – Fri</span>
                  <span data-id="element-113">3:00 pm – 8:00 pm</span>
                </div>
                <div className="flex justify-between text-sm mb-1" data-id="element-114">
                  <span data-id="element-115">Sat</span>
                  <span data-id="element-116">9:00 am – 1:00 pm</span>
                </div>
                <div className="flex justify-between text-sm text-accent" data-id="element-117">
                  <span data-id="element-118">Sun</span>
                  <span data-id="element-119">Closed</span>
                </div>
              </li>
            </ul>
          </div>

          {/* Service Area */}
          <div data-id="element-120">
            <h4 className="text-white font-heading font-bold text-lg mb-6 uppercase tracking-wide" data-id="element-121">
              Service Area
            </h4>
            <p className="text-sm text-gray-400 mb-4 leading-relaxed" data-id="element-122">
              Dragon Martial Arts of Round Lake proudly serves: Fox Lake,
              Village of Spring Grove, Round Lake, McHenry, Gurnee as well as
              all surrounding areas!
            </p>
          </div>
        </div>

        <div className="border-t border-gray-800 pt-8 text-center text-sm text-gray-500" data-id="element-123">
          <p data-id="element-124">
            &copy; 2026 Dragon Martial Arts of Round Lake. All rights reserved.
          </p>
        </div>
      </Container>
    </footer>;
}